import { useMemo } from 'react';
import { useAppStore } from '../store';

export interface TransactionDateBounds {
  minDate: string | undefined;
  maxDate: string | undefined;
}

export function useTransactionDateBounds(): TransactionDateBounds {
  const transactions = useAppStore((state) => state.transactions);

  return useMemo(() => {
    if (transactions.length === 0) {
      return { minDate: undefined, maxDate: undefined };
    }

    let minDate = transactions[0].date;
    let maxDate = transactions[0].date;

    for (const t of transactions) {
      if (t.date < minDate) minDate = t.date;
      if (t.date > maxDate) maxDate = t.date;
    }

    return { minDate, maxDate };
  }, [transactions]);
}
